<script setup>
import { ref, computed, watch, onMounted, inject } from 'vue'
import { useStore } from 'vuex'
import PlotlyLineChart from '@/components/plotly-chart/PlotlyLineChart.vue'
import { dikeProfilePlotlyMixin } from '@/mixins/dikeProfilePlotlyMixin'

const props = defineProps({
  dikeProfiles: {},
  ignoreHeight: { type: String, default: '0px' }
})

const store = useStore()
const storeNameSpace = ref('dikeProfiles')

const { baseLine, format, dikeProfilePlotDataWithHighlight } = dikeProfilePlotlyMixin()

const dikeProfilePlotData = computed(() => {
  return dikeProfilePlotDataWithHighlight(props.dikeProfiles)
})

const currentTopoProfile = computed(() => store.state.topoProfile.currentItem)
const currentDikeSection = computed(() => store.state.dikeSection.currentItem)
const singleProfiles = computed(() => store.state.dikeProfiles.singleProfiles)
const currentDikeProfile = computed(() => store.state.dikeProfiles.currentItem)
const expand = computed(() => store.state.dikeProfiles.expand)
const drawer = computed(() => store.state.project.drawer)
const showComments = computed(() => store.state.comment.show)

const setCurrentItem = (...args) => store.dispatch('dikeProfiles/setCurrentItem', ...args)

const getChartYAxisRange = computed(() => (id) => {
  return store.getters['topoProfilePoint/getChartYAxisRange'](id)
})

const plot = ref(null)

const setCurrentDikeProfile = (e) => {
  const itemId = e.points[0].data.id
  const item = props.dikeProfiles.find((item) => itemId === item.id)
  setCurrentItem(item)
}

const highlight = () => {
  if (plot.value && currentDikeProfile.value) {
    plot.value.highLightLineOnId(currentDikeProfile.value.id)
  }
}

const plotRelayout = async () => {
  await plot.value?.relayout()
}

watch(currentDikeProfile, () => {
  highlight()
})
watch(currentDikeSection, () => {
  plot.value ? plot.value.react() : null
})

watch(singleProfiles, () => plotRelayout())
watch(drawer, () => plotRelayout())
watch(expand, () => plotRelayout())
watch(showComments, () => plotRelayout())

onMounted(() => {
  highlight()
})
</script>
<template>
  <div class="chart-container">
    <PlotlyLineChart
      :data="dikeProfilePlotData"
      ref="plot"
      :refPlot="storeNameSpace"
      :base-line="baseLine"
      :format="format"
      @action="setCurrentDikeProfile"
      :click-event="true"
      :yAxisRange="getChartYAxisRange(currentTopoProfile?.id)"
    />
  </div>
</template>

<style scoped>
.chart-container {
  height: calc(100vh - v-bind(ignoreHeight));
}
</style>
